document.addEventListener("DOMContentLoaded",CRT_DOC("kn_nsk-non",0), false);

function CRT_DOC(ld_sts_base,crtpgn){
  var ld_sts = ld_sts_base.split("-")[0];
  document.getElementById("crct_hs").setAttribute("style","");
  document.getElementsByClassName("curtain_sort-main")[0].setAttribute("data-crt_reldcnc","");
  document.getElementById("curtain_sort_body_sect_04").getElementsByClassName("cr_flx_inp_01")[0].getElementsByClassName("crt_err")[0].setAttribute("class","cr_inp-box-err-hid crt_err");
  document.getElementById("curtain_sort_body_sect_04").getElementsByClassName("cr_flx_inp_02")[0].getElementsByClassName("crt_err")[0].setAttribute("class","cr_inp-box-err-hid crt_err");
  var crt_H = document.getElementById("curtain_sort_body_sect_04").getElementsByClassName("cr_inp_wndw_h")[0].value;
  var crt_W = document.getElementById("curtain_sort_body_sect_04").getElementsByClassName("cr_inp_wndw_w")[0].value;
  if(crt_H == "" || crt_W == ""){
    if(ld_sts == "kn_nsk" && crtpgn == 0){
      var CRTurl = new URL(window.location.href);
      var crt_size_base = CRTurl.searchParams.get("pscrt_hw");
      var crt_V_1 = CRTurl.searchParams.get("crtv_1");
      var crt_V_2 = CRTurl.searchParams.get("crtv_2");
      var crt_V_3 = CRTurl.searchParams.get("crtv_3");
      if(crt_size_base == null){
        var ld_sts = "ld_all";
        document.getElementsByClassName("curtain_sort-main")[0].setAttribute("data-crt_reldcnc","none");
      }else{
        if(crt_H == "" && crt_W == ""){
          document.getElementById("curtain_sort_body_sect_04").getElementsByClassName("cr_inp_wndw_h")[0].value = crt_size_base.split("_")[0];
          document.getElementById("curtain_sort_body_sect_04").getElementsByClassName("cr_inp_wndw_w")[0].value = crt_size_base.split("_")[1];
          document.getElementById("curtain_sort_body_sect_01").getElementsByClassName("cr_flx_inp")[Number(crt_V_1)].checked = true;
          document.getElementById("curtain_sort_body_sect_02").getElementsByClassName("cr_flx_inp")[Number(crt_V_2)].checked = true;
          document.getElementById("curtain_sort_body_sect_03").getElementsByClassName("cr_flx_inp")[Number(crt_V_3)].checked = true;
        }else{
          document.getElementById("curtain_sort_body_sect_04").getElementsByClassName("cr_flx_inp_01")[0].getElementsByClassName("crt_err")[0].setAttribute("class","cr_inp-box-err crt_err");
          document.getElementById("curtain_sort_body_sect_04").getElementsByClassName("cr_flx_inp_02")[0].getElementsByClassName("crt_err")[0].setAttribute("class","cr_inp-box-err crt_err");
          document.getElementsByClassName("curtain_sort-main")[0].setAttribute("data-crt_reldcnc","none");
          document.getElementById("curtain_sort_body_sect_03").scrollIntoView({ behavior: "smooth"});
          var ld_sts = "ld_all";
        };
      };
    }else{
      document.getElementById("curtain_sort_body_sect_04").getElementsByClassName("cr_flx_inp_01")[0].getElementsByClassName("crt_err")[0].setAttribute("class","cr_inp-box-err crt_err");
      document.getElementById("curtain_sort_body_sect_04").getElementsByClassName("cr_flx_inp_02")[0].getElementsByClassName("crt_err")[0].setAttribute("class","cr_inp-box-err crt_err");
      document.getElementsByClassName("curtain_sort-main")[0].setAttribute("data-crt_reldcnc","none");
      document.getElementById("curtain_sort_body_sect_03").scrollIntoView({ behavior: "smooth"});
      var ld_sts = "ld_all";
    };
  };
  
  if(ld_sts == "inp_clk" || ld_sts == "kn_nsk"){
    document.getElementsByClassName("product-list")[0].remove();
    const pr_lst_min = document.createElement("div");
    pr_lst_min.setAttribute("class","product-list product-list--collection product-list--with-sidebar");
    document.getElementsByClassName("collection__toolbar")[0].after(pr_lst_min);
  };

  var prd_pgsz = document.getElementsByClassName("curtain_sort-main")[0].getAttribute("data-prd_pg_sz");
  var pld_item_list = document.getElementById("curtain_sort-prd_base-24915");
  document.getElementById("spc_load_pap").className = "spc_load_vis";
  var upd_lnk = [];
  for(var u=1;u < Number(prd_pgsz) + 1;u++){upd_lnk.push("/collections/curtain_sort/products.json?page=" + u);};
  Promise.all(upd_lnk.map(p_url => jQuery.ajax({type: 'GET',url: p_url,dataType: 'json'})))
  .then(
    function(data){
      const alprd_data = data.reduce((acc, result) => acc.concat(result.products), []);
      var ld_sts = ld_sts_base.split("-")[0];
      var CRTurl = new URL(window.location.href);
      var prs_pgB = CRTurl.searchParams.get("page");
      if(prs_pgB == null || prs_pgB == "0" || prs_pgB == 0 || crtpgn == 0){
        var prs_pgB = 1;
      }else{
        var prs_pgB = crtpgn;
      };
      var inpL = document.getElementById("curtain_sort_body_sect_01").getElementsByClassName("cr_flx_inp")
      for(var j=0;j<inpL.length;j++){if(inpL[j].checked){var inpV01 = j};};
      var inpL = document.getElementById("curtain_sort_body_sect_02").getElementsByClassName("cr_flx_inp")
      for(var j=0;j<inpL.length;j++){if(inpL[j].checked){var inpV02 = j};};
      var inpL = document.getElementById("curtain_sort_body_sect_03").getElementsByClassName("cr_flx_inp")
      for(var j=0;j<inpL.length;j++){if(inpL[j].checked){var inpV03 = j};};
      var crt_H = document.getElementById("curtain_sort_body_sect_04").getElementsByClassName("cr_inp_wndw_h")[0].value;
      var crt_W = document.getElementById("curtain_sort_body_sect_04").getElementsByClassName("cr_inp_wndw_w")[0].value;
      if(crt_H != "" && crt_W != ""){
        CRTurl.searchParams.set("pscrt_hw",crt_H + "_" + crt_W);
        CRTurl.searchParams.set("crtv_1",inpV01);
        CRTurl.searchParams.set("crtv_2",inpV02);
        CRTurl.searchParams.set("crtv_3",inpV03);
      };
      CRTurl.searchParams.set("page",prs_pgB);
      window.history.replaceState(null, '', CRTurl);
      
      if(document.getElementById("curtain_sort_body_sect_01_inp-01").checked){
        var crt_wind_type = "01";
      }else if(document.getElementById("curtain_sort_body_sect_01_inp-02").checked){
        var crt_wind_type = "02";
      }else if(document.getElementById("curtain_sort_body_sect_01_inp-03").checked){
        var crt_wind_type = "03";
      };
      
      if(document.getElementById("curtain_sort_body_sect_03_inp-01").checked){
        var crt_open_type = "01";
      }else if(document.getElementById("curtain_sort_body_sect_03_inp-02").checked){
        var crt_open_type = "02";
      };

      if(ld_sts == "kn_nsk"){
        document.getElementById("curtain_sort_body_sect_06_color-pick").getElementsByClassName("crt_color-box")[0].remove();
        var cr_color_box = document.createElement("div");
        cr_color_box.setAttribute("class","crt_color-box");
        document.getElementById("curtain_sort_body_sect_06_color-pick").appendChild(cr_color_box);
      };
      
      var color_LIST = [];
      if(ld_sts == "inp_clk" || ld_sts == "kn_nsk"){
          var color_inp_list = document.getElementById("curtain_sort_body_sect_06_color-pick").getElementsByClassName("cr-cb_cnt");
          for(var c = 0;c < color_inp_list.length;c++){
            if(color_inp_list[c].getElementsByClassName("cr-cb_cnt_inp")[0].checked == true){
              color_LIST.push(color_inp_list[c].getElementsByClassName("cr-cb_cnt_lbl")[0].textContent);
            };
          };
        };

      var set_LIST = [];
      if(ld_sts == "inp_clk" || ld_sts == "kn_nsk"){
        for(var d = 0;d < 3;d++){
          if(document.getElementById("curtain_sort_body_sect_06").getElementsByClassName("cr_type_picker-flx")[0].getElementsByClassName("cr-cb_cnt_inp")[d].checked){
            set_LIST.push(document.getElementById("curtain_sort_body_sect_06").getElementsByClassName("cr_type_picker-flx")[0].getElementsByClassName("cr-cb_cnt_inp")[d].getAttribute("data-crt_setname"));
          };
        };
      };
      if(ld_sts == "inp_clk" || ld_sts == "kn_nsk"){        
        var spc_count = 0;
        var clr_count = 0;
        var color_int = 3;
        var crt_srt_prd_list = alprd_data;
        for(var a = 0;a < crt_srt_prd_list.length;a++){
          var color_posi = "";
          var prd_hndr = crt_srt_prd_list[a]["handle"];          
          for(var b = 0;b < crt_srt_prd_list[a]["options"].length;b++){
            if(crt_srt_prd_list[a]["options"][b]["name"] == "サイズ"){
              var size_posi = crt_srt_prd_list[a]["options"][b]["position"];
            }else if(crt_srt_prd_list[a]["options"][b]["name"] == "色"){
              var color_posi = crt_srt_prd_list[a]["options"][b]["position"];
            };
          };
          
          var crt_srt_variant_list = crt_srt_prd_list[a]["variants"];
          for(var b = 0;b < crt_srt_variant_list.length;b++){
            
            var color_thrw = false;
            var size_thrw = false;
            var type_thrw = false;
            var set_thrw = false;
            
            var crt_srt_variant = crt_srt_variant_list[b];
            var crt_var_size = crt_srt_variant["option" + size_posi];
  
            var crt_var_type = crt_var_size.split("×");
            if(crt_open_type == "01"){
              if(crt_var_type.length == 3){
                var type_thrw = true;
              }else{
                var type_thrw = false;
              };
            }else if(crt_open_type == "02"){
              if(crt_var_type.length == 2){
                var type_thrw = true;
              }else{
                var type_thrw = false;
              };
            };
  
            var crt_var_W_b = ""
            var crt_var_H_b = ""
            for(var e = 0;e < crt_var_size.split("×")[0].length;e++){
              if(isNaN(crt_var_size.split("×")[0].slice(e,e + 1)) == false){
                var crt_var_W_b = crt_var_W_b + crt_var_size.split("×")[0].slice(e,e + 1);
              };
            };
            for(var e = 0;e < crt_var_size.split("×")[1].length;e++){
              if(isNaN(crt_var_size.split("×")[1].slice(e,e + 1)) == false){
                var crt_var_H_b = crt_var_H_b + crt_var_size.split("×")[1].slice(e,e + 1);
              };
            };
            
            if(crt_open_type == "01"){
              var crt_var_W = Number(crt_var_W_b) - ((Number(crt_W)*1.05)/2);
              var crt_spc_W = (Number(crt_W)*1.05)/2;
            }else if(crt_open_type == "02"){
              var crt_var_W = Number(crt_var_W_b) - (Number(crt_W)*1.05);
              var crt_spc_W = Number(crt_W)*1.05;
            };
  
            if(crt_wind_type == "01"){
              var crt_var_H = Number(crt_var_H_b) - (Number(crt_H) - 1);
              var crt_spc_H = (Number(crt_H) - 2) + "～" + (Number(crt_H) - 1);
            }else if(crt_wind_type == "02"){
              var crt_var_H = Number(crt_var_H_b) - (Number(crt_H) + 15);
              var crt_spc_H = (Number(crt_H) + 15) + "～" + (Number(crt_H) + 20);
            }else if(crt_wind_type == "03"){
              var crt_var_H = Number(crt_var_H_b) - (Number(crt_H) - 1);
              var crt_spc_H = (Number(crt_H) - 2) + "～" + (Number(crt_H) - 1);
            };
            if(crt_wind_type == "01" || crt_wind_type == "03"){
              if(-1 < crt_var_W && crt_var_W < 50 && -6 < crt_var_H && crt_var_H < 2){
                var size_thrw = true;
              }else{
                var size_thrw = false;
              };
            }else if(crt_wind_type == "02"){
              if(-1 < crt_var_W && crt_var_W < 50 && -1 < crt_var_H && crt_var_H < 6){
                var size_thrw = true;
              }else{
                var size_thrw = false;
              };
            }

            if(color_posi != ""){
              var crt_var_color = crt_srt_variant["option" + color_posi];
              if(color_LIST.indexOf(crt_var_color) == -1 && size_thrw == true && type_thrw == true && ld_sts == "kn_nsk"){
                color_LIST.push(crt_var_color);
                var color_int = color_int + 1;
                MK_color_INP(crt_var_color,color_int);
              };
            };

            if(ld_sts == "kn_nsk"){
              var color_thrw = true;
            }else{
              if(color_posi != "" && color_LIST.length > 0){
                if(color_LIST.indexOf(crt_srt_variant["option" + color_posi]) >= 0){
                  var color_thrw = true;
                }else{
                  var color_thrw = false;
                };
              }else if(color_LIST.length == 0){
                var color_thrw = true;
              }else{
                var color_thrw = false;
              };
            };
  
            if(set_LIST.length != 0){
              var set_thrw = false;
              var crt_tags = crt_srt_prd_list[a]["tags"];
              for(var d = 0;d < crt_tags.length;d++){
                if(set_LIST.indexOf(crt_tags[d]) > -1){
                  if(crt_tags[d] == "レースカーテン"){var color_thrw = true;};
                  var set_thrw = true;
                };
              };
            }else{
              var set_thrw = true;
            };

            var crt_tags = crt_srt_prd_list[a]["tags"];
            for(var d = 0;d < crt_tags.length;d++){
              if(crt_tags[d] == "ドレープカーテン"){
                var crt_tag_settype = "ドレープカーテン";
              }else if(crt_tags[d] == "レースカーテン"){
                var crt_tag_settype = "レースカーテン";
              }else if(crt_tags[d] == "ドレープレースセットカーテン"){
                var crt_tag_settype = "ドレープレースセット";
              };
            };
            
            if(color_thrw == true && size_thrw == true && type_thrw == true && set_thrw == true){
              
              var spc_count = spc_count + 1;
              var spc_start = ((prs_pgB - 1) * 24) + 1
              var spc_end = prs_pgB * 24
              
              if(spc_count >= spc_start && spc_count <= spc_end){
                var clr_count = clr_count + 1;
                var nw_prd_item = CRT_MK(pld_item_list);
                if(crt_srt_variant["featured_image"]["src"].indexOf("/products/") > 0){
                  var prd_src = "//pandaselections.com/cdn/shop/products/" + crt_srt_variant["featured_image"]["src"].split("/products/").slice(-1)[0];
                }else{
                  var prd_src = "//pandaselections.com/cdn/shop/files/" + crt_srt_variant["featured_image"]["src"].split("/files/").slice(-1)[0];
                };
                var frm_d = nw_prd_item.getElementsByClassName("product-item__action-list")[0].getAttribute("id");
                var frm_d_data = "product_form_id_" + crt_srt_variant["id"] + "_template--" + frm_d.split("_template--")[1];
                nw_prd_item.getElementsByClassName("product-item__action-list")[0].setAttribute("id",frm_d_data);
                nw_prd_item.getElementsByClassName("product-item__image-wrapper ")[0].setAttribute("href","");
                nw_prd_item.getElementsByClassName("product-item__image-wrapper ")[0].setAttribute("style","pointer-events:none;")
                nw_prd_item.getElementsByClassName("product-item__primary-image ")[0].setAttribute("src",prd_src);
                nw_prd_item.getElementsByClassName("product-item__secondary-image")[0].setAttribute("data-srcset","");
                nw_prd_item.getElementsByClassName("product-item__secondary-image")[0].setAttribute("srcset",prd_src);
                nw_prd_item.getElementsByClassName("product-item__secondary-image")[0].setAttribute("class","");
                
                nw_prd_item.removeAttribute("id");
                nw_prd_item.removeAttribute("style");
                if(spc_count == 1){
                  document.getElementById("prd_crtn_prf-spec-box").setAttribute("class","prd_crtn_prf-spec");
                  document.getElementById("prd_crtn_prf-spec-box").getElementsByClassName("prd_crtn_recom_spec")[0].innerText = "入力サイズ　幅：" + crt_W + "cm / 丈：" + crt_H + "cm\n推奨サイズ　幅：" + crt_spc_W + "cm / 丈：" + crt_spc_H + "cm";
                };
                nw_prd_item.getElementsByClassName("product-item__title")[0].textContent = crt_tag_settype;
                nw_prd_item.getElementsByClassName("product-item__title")[0].setAttribute("data-crtprd_ttl",crt_srt_prd_list[a]["title"]);
                nw_prd_item.getElementsByClassName("product-item__title")[0].setAttribute("href","");
                nw_prd_item.getElementsByClassName("product-item__title")[0].setAttribute("style","pointer-events:none;")
                nw_prd_item.getElementsByClassName("product-item__vendor")[0].textContent = crt_srt_prd_list[a]["vendor"];
                nw_prd_item.getElementsByClassName("product-item__vendor")[0].setAttribute("href","");
                nw_prd_item.getElementsByClassName("product-item__vendor")[0].setAttribute("style","pointer-events:none;")
                var crt_prd_images = "";for(var f=0;f<crt_srt_prd_list[a]["images"].length;f++){var crt_prd_images = crt_prd_images + crt_srt_prd_list[a]["images"][f]["src"] + "|^|"};
                nw_prd_item.getElementsByClassName("curtain_body_content")[0].setAttribute("data-prd_images",crt_prd_images);
                var crt_prd_variant_title = document.createElement("div");crt_prd_variant_title.setAttribute("class","crt_prd_variant_title");
                var crt_prd_variant_title_text = document.createElement("div");crt_prd_variant_title_text.innerText = crt_srt_variant["title"].replace(" / ","\n");crt_prd_variant_title_text.setAttribute("data-crt_v_ttl",crt_srt_variant["title"]);crt_prd_variant_title_text.setAttribute("class","crt_prd_variant_title_text");crt_prd_variant_title.appendChild(crt_prd_variant_title_text);
                nw_prd_item.getElementsByClassName("product-item__title")[0].after(crt_prd_variant_title);
                var ttlnd_prc = document.createTextNode("\xA5" + crt_srt_variant["price"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                nw_prd_item.getElementsByClassName("price")[0].appendChild(ttlnd_prc);
                var bdy_cnt = DOMPurify.sanitize(crt_srt_prd_list[a]["body_html"]);
                var dc_range = document.createRange();
                var dc_bdy_cnt = dc_range.createContextualFragment(bdy_cnt);
                var crt_vid_prd = "crt_vd_" + crt_srt_variant["id"];
                var qv_btn = document.createElement("div");qv_btn.textContent = "詳細を確認";qv_btn.setAttribute("class","crtn_qv_btn");qv_btn.setAttribute("onclick","INPD_T_QV(this)");nw_prd_item.getElementsByClassName("product-item__info")[0].appendChild(qv_btn);
                var crt_fd = nw_prd_item.getElementsByClassName("product-item__action-list")[0].getAttribute("id").split("_template--");
                nw_prd_item.getElementsByClassName("product-item__action-list")[0].setAttribute("id","product_form_id_" + crt_srt_variant["id"] + "_template--" + crt_fd[1]);
                var crt_fd_inp = nw_prd_item.getElementsByClassName("product-item__action-list")[0].getElementsByTagName("input");
                for(var g=0;g<crt_fd_inp.length;g++){if(crt_fd_inp[g].getAttribute("name") == "id"){crt_fd_inp[g].setAttribute("value",crt_srt_variant["id"]);};};
                nw_prd_item.getElementsByClassName("curtain_body_content")[0].appendChild(dc_bdy_cnt);
                document.getElementsByClassName("product-list")[0].appendChild(nw_prd_item);
              };
            };
          };
        };
        if(document.getElementsByClassName("collection")[0].getElementsByClassName("empty-state").length > 0){
          document.getElementsByClassName("collection")[0].getElementsByClassName("empty-state")[0].remove();
        };
        if(spc_count == 0){
          if(document.getElementsByClassName("curtain_sort-main")[0].getAttribute("data-crt_reldcnc") != "none"){
            if(document.querySelectorAll(".empty-state.empty-state--tight").length > 0){document.querySelectorAll(".empty-state.empty-state--tight")[0].remove();};
            document.getElementById("curtain_sort_body_sect_06").setAttribute("class","curtain_sort_body_sect-hid");
            const fail_emp = document.createElement("div");
            fail_emp.setAttribute("class","empty-state empty-state--tight");
            const emp_txt = document.createElement("p");
            emp_txt.setAttribute("class","emp_cnt_msg")
            emp_txt.setAttribute("style","text-align:left;padding:30px;border-top:1px solid #e1e3e4;margin-top:0px;")
            emp_txt.innerText = "ご希望に沿った商品がヒットしませんでした。\n申し訳ございませんが、検索条件を変更して再度お試しください。\n\n既製品カーテンの他に、オーダーカーテンも取り扱っております。以下のリンクからお見積もりフォームをご確認いただけます。";
            fail_emp.appendChild(emp_txt);
            const emp_link = document.createElement("a");
            emp_link.textContent = "オーダーカーテンお見積もりフォーム";
            emp_link.setAttribute("class","err_emp_link");
            emp_link.setAttribute("href","/pages/order_curtain_estimate");
            fail_emp.appendChild(emp_link);
            document.getElementsByClassName("collection__toolbar")[0].after(fail_emp);
            document.getElementById("prd_crtn_prf-spec-box").setAttribute("class","prd_crtn_prf-spec_hidden");
            document.getElementById("spc_load_pap").className = "spc_load_hid";
            document.getElementById("crct_hs").setAttribute("style","display:none;");
          }else{
            document.getElementById("spc_load_pap").className = "spc_load_hid";
            document.getElementById("crct_hs").setAttribute("style","display:none;");
          };
        }else{
          MK_PGNT_BAR(spc_count,prs_pgB);
          document.getElementById("curtain_sort_body_sect_06").setAttribute("class","curtain_sort_body_sect");
          document.getElementById("spc_load_pap").className = "spc_load_hid";
          if(ld_sts_base.split("-")[1] == "scr"){
            document.getElementById("crt_clr_scrl_00").scrollIntoView({ behavior: "smooth"});
          };
        };
      }else{
        document.getElementById("spc_load_pap").className = "spc_load_hid";
      };
    }
  )
  .catch(
    function(data){
      /*console.log(data);*/
      if(ld_sts != "ld_all"){
        if(document.querySelectorAll(".empty-state.empty-state--tight").length > 0){document.querySelectorAll(".empty-state.empty-state--tight")[0].remove();};
        const fail_emp = document.createElement("div");
        fail_emp.setAttribute("class","empty-state empty-state--tight");
        const emp_txt = document.createElement("p");
        emp_txt.setAttribute("class","emp_cnt_msg")
        emp_txt.textContent = "ページ情報の取得に失敗しました。恐れ入りますが、ページ更新後に再度お試しください。";
        fail_emp.appendChild(emp_txt);
        document.getElementsByClassName("collection__toolbar")[0].after(fail_emp);
      };
      document.getElementById("spc_load_pap").className = "spc_load_hid";
    }
  )
};

function CRT_MK(Nd_d_v) {
  const newElement = document.createElement(Nd_d_v.tagName);
  if (Nd_d_v.attributes) {
    for(var n = 0;n < Nd_d_v.attributes.length;n++){
      var Pnd_n = Nd_d_v.attributes[n].name;
      var Pnd_v = Nd_d_v.attributes[n].value;
      newElement.setAttribute(Pnd_n, Pnd_v);
    };
  };
  if (Nd_d_v.textContent) {
    if(Nd_d_v.childNodes[0].nodeType == 3 && Nd_d_v.className != "visually-hidden"){
      if(Nd_d_v.className == "product-item__title text--strong link"){
        if(Nd_d_v.childNodes[2]){
          newElement.textContent = Nd_d_v.childNodes[0].nodeValue;
          const PSbrnk = document.createElement("br");
          newElement.appendChild(PSbrnk);
          const ttlnd = document.createTextNode(Nd_d_v.childNodes[2].nodeValue)
          newElement.appendChild(ttlnd);
        }else{
          newElement.textContent = Nd_d_v.childNodes[0].nodeValue;
        };
      }else if(Nd_d_v.className == "price"){
        const vhid = document.createElement("span");
        vhid.setAttribute("class","visually-hidden");
        vhid.textContent = "販売価格";
        newElement.appendChild(vhid);
      }else{
        newElement.textContent = Nd_d_v.childNodes[0].nodeValue;
      };
    };
  };
  if (Nd_d_v.children) {
    for(var i = 0;i < Nd_d_v.children.length;i++){
      if(Nd_d_v.children[i].tagName != "BR" && Nd_d_v.children[i].className != "visually-hidden" ){
        var cLEm = CRT_MK(Nd_d_v.children[i]);
        newElement.appendChild(cLEm);
      };
    };
  };
  return newElement;
};

function MK_color_INP(crt_clr,clr_num){
  var cr_lbl = document.createElement("label");
  cr_lbl.setAttribute("class","cr-cb_cnt");
  cr_lbl.setAttribute("for","curtain_sort_body_sect_06_inp-" + String(clr_num));
  var cr_inp = document.createElement("input");
  cr_inp.setAttribute("class","cr-cb_cnt_inp");
  cr_inp.setAttribute("type","checkbox");
  cr_inp.setAttribute("id","curtain_sort_body_sect_06_inp-" + String(clr_num));
  cr_inp.setAttribute("onclick","CRT_DOC('inp_clk-non',1)");
  var cr_div = document.createElement("div");
  cr_div.setAttribute("class","cr-cb_cnt_lbl");
  cr_div.textContent = crt_clr;
  cr_lbl.appendChild(cr_inp);
  cr_lbl.appendChild(cr_div);
  document.getElementById("curtain_sort_body_sect_06_color-pick").getElementsByClassName("crt_color-box")[0].appendChild(cr_lbl);
};

function TYP_RDO(ths_id){
  var rdo_inp = document.getElementById("curtain_sort_body_sect_06").getElementsByClassName("cr-cb_cnt_inp");
  var chk_contnt = false;
  for(a = 0;a < rdo_inp.length;a++){
    if(rdo_inp[a].getAttribute("id") == ths_id){
      if(document.getElementById(ths_id).getAttribute("data-crt_rdo_chk") == "checked"){
        document.getElementById(ths_id).setAttribute("data-crt_rdo_chk","");
        document.getElementById(ths_id).checked = false;
      }else{
        document.getElementById(ths_id).setAttribute("data-crt_rdo_chk","checked");
        if(ths_id == "curtain_sort_body_sect_06_inp-3"){
          document.getElementById("curtain_sort_body_sect_06_cr-tzr_mark").checked = false;
          document.getElementById("curtain_sort_body_sect_06_cr-tzr_mark").setAttribute("disabled","true");
          document.getElementById("curtain_sort_body_sect_06").getElementsByTagName("path")[0].setAttribute("color","#fff");
          document.getElementById("curtain_sort_body_sect_06").getElementsByClassName("cr-tzr_text")[0].setAttribute("style","color:#e8e8e8;");
          var chk_contnt = true;
        }else{
          document.getElementById("curtain_sort_body_sect_06_cr-tzr_mark").checked = true;
          document.getElementById("curtain_sort_body_sect_06_cr-tzr_mark").removeAttribute("disabled");
          document.getElementById("curtain_sort_body_sect_06").getElementsByTagName("path")[0].setAttribute("color","");
          document.getElementById("curtain_sort_body_sect_06").getElementsByClassName("cr-tzr_text")[0].setAttribute("style","");
          var chk_contnt = true;
        };
      };
    }else{
      rdo_inp[a].setAttribute("data-crt_rdo_chk","");
    };
  };
  if(chk_contnt == false){
    document.getElementById("curtain_sort_body_sect_06_cr-tzr_mark").checked = true;
    document.getElementById("curtain_sort_body_sect_06_cr-tzr_mark").removeAttribute("disabled");
    document.getElementById("curtain_sort_body_sect_06").getElementsByTagName("path")[0].setAttribute("color","");
    document.getElementById("curtain_sort_body_sect_06").getElementsByClassName("cr-tzr_text")[0].setAttribute("style","");
  };
  CRT_DOC("inp_clk-non",1);
};

function INPD_T_QV(crt_f_dt){
  var par_cnt = crt_f_dt.parentElement.parentElement;
  var qv_main_ttl = par_cnt.getElementsByClassName("product-item__title")[0].getAttribute("data-crtprd_ttl");
  var qv_typ_ttl = par_cnt.getElementsByClassName("product-item__title")[0].textContent;
  var qv_bdy = par_cnt.getElementsByClassName("curtain_body_content")[0].cloneNode(true);
  var qv_main_img = par_cnt.getElementsByClassName("product-item__primary-image ")[0].getAttribute("src");
  var qv_imgs_list = par_cnt.getElementsByClassName("curtain_body_content")[0].getAttribute("data-prd_images").split("|^|");
  document.getElementById("brn_opn_back_").getElementsByClassName("brn_prd_qv_imgs-list-caset")[0].remove();
  document.getElementById("brn_opn_back_").getElementsByClassName("brn_prd_qv-inf_prd-dscr-cont")[0].remove();
  var qv_imgs_list_caset = document.createElement("div");
  qv_imgs_list_caset.setAttribute("class","brn_prd_qv_imgs-list-caset")
  for(var a=0;a < qv_imgs_list.length;a++){
    var qv_imgs = document.createElement("img");
    qv_imgs.setAttribute("src",qv_imgs_list[a]);
    qv_imgs.setAttribute("onclick","QV_MAIN_IMG_CNG(this)");
    qv_imgs_list_caset.appendChild(qv_imgs);
  };
  document.getElementById("brn_opn_back_").getElementsByClassName("brn_prd_qv-inf_prd-ttl")[0].getElementsByClassName("brn_prd_qv-inf_prd-ttl_main")[0].textContent = qv_main_ttl
  document.getElementById("brn_opn_back_").getElementsByClassName("brn_prd_qv-inf_prd-ttl")[0].getElementsByClassName("brn_prd_qv-inf_prd-ttl_sub")[0].innerText = "■" + qv_typ_ttl + "\n■" + par_cnt.getElementsByClassName("crt_prd_variant_title_text")[0].getAttribute("data-crt_v_ttl");
  document.getElementById("brn_opn_back_").getElementsByClassName("brn_prd_qv-inf_prd-dscr")[0].appendChild(qv_bdy);
  document.getElementById("brn_opn_back_").getElementsByClassName("brn_prd_qv-inf_prd-dscr")[0].getElementsByClassName("curtain_body_content")[0].setAttribute("class","brn_prd_qv-inf_prd-dscr-cont");
  document.getElementById("brn_opn_back_").getElementsByClassName("brn_prd_qv_img-main-img")[0].setAttribute("src",qv_main_img);
  document.getElementById("brn_opn_back_").getElementsByClassName("brn_prd_qv_imgs-list")[0].appendChild(qv_imgs_list_caset);
  document.getElementById("brn_opn_back_").setAttribute("class","btn_prd_qv_back");
};

function QV_MAIN_IMG_CNG(crt_t_img_list){
  var qv_imgs_list = document.getElementById("brn_opn_back_").getElementsByClassName("brn_prd_qv_imgs-list-caset")[0].getElementsByTagName("img");
  for(var a=0;a < qv_imgs_list.length;a++){
    qv_imgs_list[a].setAttribute("style","");
  };
  crt_t_img_list.setAttribute("style","border:solid 5px #00badb;padding:2px;");
  document.getElementById("brn_opn_back_").getElementsByClassName("brn_prd_qv_img-main-img")[0].setAttribute("src",crt_t_img_list.getAttribute("src"));
};

function CRT_ADT_CT(crt_t_prd){
  var crt_vd = crt_t_prd.getAttribute("data-crt_vd").replace("crt_vd_","");
  document.getElementById("spc_load_pap").className = "spc_load";
  jQuery.ajax({type: 'POST',url: '/cart/add.js',dataType:"text",data: {items:[{id: crt_vd,quantity: 1}]}})
  .then(function(){
    document.getElementById("spc_load_pap").className = "spc_load_hid";
    })
  .fail(function(){
    document.getElementById("spc_load_pap").className = "spc_load_hid";
  })
};

function MK_PGNT_BAR(crt_vr_count,prs_pg){
  var pg_pat = document.getElementsByClassName("curtain_sort-main")[0].getAttribute("data-pghrf");
  var pg_nav = document.createElement("div");pg_nav.setAttribute("class","pagination__nav");document.getElementsByClassName("pagination")[0].getElementsByClassName("pagination__page-count")[0].before(pg_nav);
  var base_count = document.getElementsByClassName("curtain_sort-main")[0].getAttribute("data-pgnt");
  var pgnt_count = Math.floor(crt_vr_count / base_count) + 1;
  document.getElementsByClassName("pagination")[0].getElementsByClassName("pagination__page-count")[0].textContent = pgnt_count + "ページ中" + prs_pg + "ページ";
  document.getElementsByClassName("pagination")[0].getElementsByClassName("pagination__prev link")[0].setAttribute("onclick","CRT_DOC('inp_clk-scr'," + (prs_pg - 1) + ")");
  document.getElementsByClassName("pagination")[0].getElementsByClassName("pagination__prev link")[0].setAttribute("style","");
  document.getElementsByClassName("pagination")[0].getElementsByClassName("pagination__next link")[0].setAttribute("onclick","CRT_DOC('inp_clk-scr'," + (prs_pg + 1) + ")");
  document.getElementsByClassName("pagination")[0].getElementsByClassName("pagination__next link")[0].setAttribute("style","");
  if(prs_pg == 1){
    if(pgnt_count == 1){
      document.getElementsByClassName("pagination")[0].getElementsByClassName("pagination__next link")[0].removeAttribute("onclick");
      document.getElementsByClassName("pagination")[0].getElementsByClassName("pagination__next link")[0].setAttribute("style","visibility:hidden;opacity:0;");
    };
    document.getElementsByClassName("pagination")[0].getElementsByClassName("pagination__prev link")[0].removeAttribute("onclick");
    document.getElementsByClassName("pagination")[0].getElementsByClassName("pagination__prev link")[0].setAttribute("style","visibility:hidden;opacity:0;");
  }else if(prs_pg == pgnt_count){
    document.getElementsByClassName("pagination")[0].getElementsByClassName("pagination__next link")[0].removeAttribute("onclick");
    document.getElementsByClassName("pagination")[0].getElementsByClassName("pagination__next link")[0].setAttribute("style","visibility:hidden;opacity:0;");
  };
  document.getElementsByClassName("pagination")[0].getElementsByClassName("pagination__nav")[0].remove();
  for(var a = 1;a <= pgnt_count;a++){
    var pg_prv = prs_pg - 3;
    var pg_nxt = pgnt_count - (prs_pg + 3);
    if(a == prs_pg){
      mk_crt_inn_spn_1(a);
    }else if(a == 1){
      mk_crt_inn_lnk(a);
    }else if(a == pgnt_count){
      mk_crt_inn_lnk(a);
    }else{
      if(pg_prv > 2){
        if(a > prs_pg - 3 && prs_pg > a){
          mk_crt_inn_lnk(a);
        }else if(a == prs_pg - 3){
          mk_crt_inn_spn_2();
        };
      }else{
        if(a < prs_pg){
          mk_crt_inn_lnk(a);
        };
      };
      if(pg_nxt > 2){
        if(a < prs_pg + 3 && prs_pg < a){
          mk_crt_inn_lnk(a);
        }else if(a == prs_pg + 3){
          mk_crt_inn_spn_2();
        };
      }else{
        if(a > prs_pg){
          mk_crt_inn_lnk(a);
        };
      };
    };
  };
};

function mk_crt_inn_spn_1(crt_int){
  var pgnt_inr = document.createElement("span");
  pgnt_inr.setAttribute("class","pagination__nav-item is-active");
  pgnt_inr.textContent = crt_int;
  document.getElementsByClassName("pagination")[0].getElementsByClassName("pagination__nav")[0].appendChild(pgnt_inr);
};
function mk_crt_inn_spn_2(){
  var pgnt_inr = document.createElement("span");
  pgnt_inr.setAttribute("class","pagination__nav-item");
  pgnt_inr.textContent = "...";
  document.getElementsByClassName("pagination")[0].getElementsByClassName("pagination__nav")[0].appendChild(pgnt_inr);
};
function mk_crt_inn_lnk(crt_int){
  var pg_pat = document.getElementsByClassName("curtain_sort-main")[0].getAttribute("data-pghrf");
  var pgnt_inr = document.createElement("div");
  pgnt_inr.setAttribute("class","pagination__nav-item link");
  pgnt_inr.setAttribute("onclick","CRT_DOC('inp_clk-scr'," + crt_int + ")");
  pgnt_inr.textContent = crt_int;
  document.getElementsByClassName("pagination")[0].getElementsByClassName("pagination__nav")[0].appendChild(pgnt_inr);
}

function CLS_CRT_DLG(){
  document.getElementById("brn_opn_back_").setAttribute("class","btn_prd_qv_back_hid");
};